import { render, staticRenderFns } from "./ManufacturerView.vue?vue&type=template&id=75bc7947&"
import script from "./ManufacturerView.vue?vue&type=script&lang=js&"
export * from "./ManufacturerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports